export default class ParentalControl {
    show = false;
    code = '';
    hasLogout = false;
}
